// mutation types
export const SET_PERMISSION = 'setListPermission';

export default {
    state: {
        listPermission: []
    },
    getters: {
        /**
         * Get list of menu for current page
         * @param state
         * @returns {*}
         */
        listPermission(state) {
            return state.listPermission;
        },

        /**
         * Check permission
         * @param state
         * @returns {*}
         */
        checkPermission(state) {
            return (permission) => {
                return state.listPermission.includes(permission);
            };
        },
    },
    actions: {
        /**
         * Set the menu list
         * @param state
         * @param payload
         */
        [SET_PERMISSION](state, payload) {
            state.commit(SET_PERMISSION, payload);
        },
    },
    mutations: {
        [SET_PERMISSION](state, payload) {
            state.listPermission = payload;
            // Sync sang localStorage để các hàm cũ trong saveDataToLocal dùng listFeature vẫn đúng
            window.localStorage.setItem('listFeature', Array.isArray(payload) ? payload.join(',') : '');
        },
    }
};
